import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    num: '01', icon: '🌲', title: 'Ham Kereste Üretimi',
    desc: 'Sürdürülebilir ormanlardan FSC sertifikalı olarak tedarik ettiğimiz ahşabı, modern kurutma fırınları ve işleme makinelerimizle en kaliteli kereste haline getiriyoruz.',
    items: ['Meşe, ceviz, gürgen, ladin', 'Doğal ve yapay kurutma', 'Her boyut ve kesitte üretim', 'Stok ve sipariş bazlı tedarik'],
  },
  {
    num: '02', icon: '🪵', title: 'Özel Mobilya Tasarımı',
    desc: 'Yaşam ve çalışma alanlarınıza özel, ergonomik ve estetik mobilyaları deneyimli tasarımcılarımız ve ustalarımızla hayata geçiriyoruz.',
    items: ['3D tasarım ve prototipleme', 'Masif ve panel mobilya', 'Otel ve ofis projeleri', 'Tadilat ve yenileme'],
  },
  {
    num: '03', icon: '🏠', title: 'İç Mekan Kaplama',
    desc: 'Duvar, tavan ve zemin kaplamalarında doğal ahşabın sıcaklığını yaşam alanlarınıza getiriyoruz. Her zemin tipine uygun çözümlerimiz mevcuttur.',
    items: ['Laminat ve masif parke', 'Duvar ve tavan paneli', 'Özel boy ve profil üretimi', 'Uygulama ve montaj'],
  },
  {
    num: '04', icon: '🚪', title: 'Kapı & Pencere Sistemleri',
    desc: 'Masif ahşap ve ahşap-alüminyum kompozit sistemlerle iç ve dış mekan kapı-pencere çözümleri üretiyoruz.',
    items: ['İç kapı ve çerçeve sistemleri', 'Dış cephe kapı & pencere', 'Ahşap-Alüminyum kompozit', 'Özel ölçü ve tasarım'],
  },
  {
    num: '05', icon: '🏗️', title: 'Ahşap Yapı Sistemleri',
    desc: 'Prefabrik ahşap evlerden büyük ticari projelere kadar çevre dostu, depreme dayanıklı ahşap konstrüksiyon sistemleri kuruyoruz.',
    items: ['Prefabrik ahşap ev', 'Çatı ve iskelet sistemleri', 'Pergola ve kiosk', 'Endüstriyel ahşap yapı'],
  },
  {
    num: '06', icon: '✨', title: 'Restorasyon & Onarım',
    desc: 'Tarihi ve değerli ahşap eserlerin, antika mobilyaların ve mimari unsurların orijinal dokusunu koruyarak yenileme hizmetleri sunuyoruz.',
    items: ['Tarihi yapı restorasyonu', 'Antika mobilya onarımı', 'Yüzey temizleme ve cilalama', 'Renk ve doku eşleştirme'],
  },
];

const process = [
  { num: '01', title: 'Danışma & Analiz', desc: 'Projenizi detaylıca dinliyor, ihtiyaçlarınızı analiz ediyor ve en uygun çözümü birlikte belirliyoruz.' },
  { num: '02', title: 'Tasarım & Teklif', desc: '3D görselleştirme ve detaylı teklifle projenizin nasıl görüneceğini onayınıza sunuyoruz.' },
  { num: '03', title: 'Üretim', desc: 'Onaylanan tasarımı uzman ekibimiz ve modern makinelerimizle hayata geçiriyoruz.' },
  { num: '04', title: 'Teslim & Montaj', desc: 'Ürünlerinizi zamanında teslim ediyor, montajını gerçekleştiriyor ve memnuniyetinizi sağlıyoruz.' },
];

export default function Hizmetler() {
  return (
    <>
      <div className="page-hero">
        <div className="page-hero-content">
          <div className="page-hero-tag">Hizmetlerimiz</div>
          <h1>Ahşapta Her Şey<br /><em>Tek Çatı Altında</em></h1>
        </div>
      </div>

      <section className="section">
        <div className="section-tag">Ne Yapıyoruz</div>
        <div className="services-header">
          <div className="section-title">Kapsamlı<br />Ahşap Çözümleri</div>
          <p className="section-sub">Ham malzemeden son ürüne kadar tüm süreçleri kendi bünyemizde gerçekleştiriyoruz.</p>
        </div>
        <div className="services-page-grid">
          {services.map((s, i) => (
            <div className="service-page-card" key={i}>
              <div className="service-page-num">{s.num}</div>
              <div style={{fontSize:'32px', marginBottom:'16px'}}>{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              <ul>
                {s.items.map((item, j) => <li key={j}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* SÜREÇ */}
      <section className="section about-bg">
        <div className="section-tag">Nasıl Çalışırız</div>
        <div className="section-title">Proje Sürecimiz</div>
        <div className="process-steps">
          {process.map((p, i) => (
            <div className="process-step" key={i}>
              <div className="step-num">{p.num}</div>
              <h4>{p.title}</h4>
              <p>{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="testimonial">
        <div className="testimonial-inner">
          <div style={{fontSize:'48px', marginBottom:'24px'}}>🤝</div>
          <p className="testimonial-text">Projeniz için en uygun hizmeti birlikte belirleyelim. Uzman ekibimiz size özel çözümler sunar.</p>
          <div style={{marginTop:'40px', display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
            <Link to="/iletisim" className="btn-primary">Ücretsiz Danışmanlık Al</Link>
          </div>
        </div>
      </section>
    </>
  );
}
